"use client";

import Link from "next/link";

export default function PoolError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4 px-6">
      <h2
        className="text-[20px] font-medium"
        style={{ color: "var(--text-primary)" }}
      >
        Something went wrong
      </h2>
      <p
        className="text-[13px] max-w-md text-center"
        style={{ color: "var(--text-secondary)" }}
      >
        {error.message || "Unable to load pool data. Please try again."}
      </p>
      <div className="flex gap-3">
        <button
          onClick={reset}
          className="px-4 py-2 rounded-lg text-[12px] font-medium"
          style={{ background: "var(--accent)", color: "var(--bg)" }}
        >
          Try again
        </button>
        <Link
          href="/pools"
          className="px-4 py-2 rounded-lg text-[12px] font-medium"
          style={{ background: "#141414", color: "#888", border: "1px solid #222" }}
        >
          Back to pools
        </Link>
      </div>
    </div>
  );
}
